/**
 * One person, other than a dashboard's owner, whose work some of its widgets
 * load (POST /dashboards/:customer/:id/promote, `foreign_refs`). Those
 * widgets stay empty for anyone who may not see that person's work, because
 * the customer's email domain list (migration 000156) hides it and the
 * dashboard only grants its owner's own tables and chats.
 */
export interface DashboardForeignRef {
  owner: string
  kind: 'table' | 'chat'
  widgets: number
}

const widgetsUse = (n: number) => (n === 1 ? '1 widget uses' : `${n} widgets use`)

/** The warning shown after promoting, or null when every widget is the owner's own. */
export function promotionWarning(refs: DashboardForeignRef[] | undefined | null): string | null {
  if (!refs || refs.length === 0) return null
  const sentences = refs.map((r) => {
    const what = r.kind === 'chat' ? `a chat by ${r.owner}` : `tables from ${r.owner}'s My Tables`
    const fix = r.kind === 'chat' ? 'Add those from your own chats instead.' : 'Copy them to your own tables first.'
    return `${widgetsUse(r.widgets)} ${what}; people who can't see ${r.owner}'s work will see ${r.widgets === 1 ? 'it' : 'them'} empty. ${fix}`
  })
  return `Promoted to Company-level. ${sentences.join(' ')}`
}
